import { render, staticRenderFns } from "./TripleTemperatureSetting.vue?vue&type=template&id=f3fff32c&scoped=true"
import script from "./TripleTemperatureSetting.vue?vue&type=script&lang=js"
export * from "./TripleTemperatureSetting.vue?vue&type=script&lang=js"
import style0 from "./TripleTemperatureSetting.vue?vue&type=style&index=0&id=f3fff32c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fff32c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3fff32c')) {
      api.createRecord('f3fff32c', component.options)
    } else {
      api.reload('f3fff32c', component.options)
    }
    module.hot.accept("./TripleTemperatureSetting.vue?vue&type=template&id=f3fff32c&scoped=true", function () {
      api.rerender('f3fff32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TripleTemperatureSetting.vue"
export default component.exports